import styled from "styled-components";

interface HeaderPageProps {
  $isOpen: boolean;
}

export const HeaderPage = styled.div<HeaderPageProps>`
  position: fixed;
  top: 0;
  right: 0;
  height: 75px;
  background: var(--backgroundColorCard);
  border-bottom: 1px solid var(--border);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  left: 0;
  transition: all 0.3s;
  z-index: 99;
`;

export const LogoHeader = styled.img`
  width: 90px;
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Helvetica Neue Medium";
  font-size: 1.4rem;
  display: none;

  @media (min-width: 992px) {
    display: block;
  }
`;

export const BoxSearch = styled.div`
  max-width: 576px;
  width: calc(100% - 529px);
  margin: 0 15px 0 0;

  @media (min-width: 992px) {
    margin: 0 3rem;
  }
`;

export const BoxLastItemsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;
